import styled, { css } from 'styled-components';

export interface IAlign {
  $align?: 'start' | 'center' | 'end';
  $alignSm?: 'start' | 'center' | 'end';
  $alignMd?: 'start' | 'center' | 'end';
}

export const Align = styled.div.withConfig({ componentId: 'sc-lv6wyv-0' })<IAlign>`
    display: flex;

    ${({ $align }) =>
      $align === 'center'
        ? css`
                  justify-content: center;
              `
        : $align === 'end'
          ? css`
                  justify-content: flex-end;
              `
          : $align === 'start'
            ? css`
                  justify-content: flex-start;
              `
            : undefined}

    ${({ $alignSm }) =>
      $alignSm === 'center'
        ? css`
                  ${(props) => props.theme.breakpoint.Sm} {
                      justify-content: center;
                  }
              `
        : $alignSm === 'end'
          ? css`
                  ${(props) => props.theme.breakpoint.Sm} {
                      justify-content: flex-end;
                  }
              `
          : $alignSm === 'start'
            ? css`
                  ${(props) => props.theme.breakpoint.Sm} {
                      justify-content: flex-start;
                  }
              `
            : undefined}

  ${({ $alignMd }) =>
    $alignMd === 'center'
      ? css`
                  ${(props) => props.theme.breakpoint.Md} {
                      justify-content: center;
                  }
              `
      : $alignMd === 'end'
        ? css`
                  ${(props) => props.theme.breakpoint.Md} {
                      justify-content: flex-end;
                  }
              `
        : $alignMd === 'start'
          ? css`
                  ${(props) => props.theme.breakpoint.Md} {
                      justify-content: flex-start;
                  }
              `
          : undefined}
`;
